import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemLink from "./util/ListItemLink";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ListIcon from "@mui/icons-material/ListRounded";
import AssessmentIcon from "@mui/icons-material/AssessmentRounded";
import AssignmentIcon from "@mui/icons-material/AssignmentRounded";
import FolderIcon from "@mui/icons-material/Folder";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmarkRounded";

export const mainListItems = (
  <div>
    <ListItemLink to="/summary" primary="Summary" icon={<DashboardIcon />} />
    <ListItemLink to="/tasks" primary="Tasks" icon={<ListIcon />} />
    <ListItemLink
      to="/distributions"
      primary="Configure Distribution"
      icon={<EqualizerIcon />}
    />
    {/*<ListItemLink to="/analysis" primary="Analysis" icon={<AssessmentIcon />} />*/}
    <ListItemLink
      to="/baselines"
      primary="Manage Baselines"
      icon={<CollectionsBookmarkIcon />}
    />
    <ListItemLink
      to="/projects"
      primary="Manage Projects"
      icon={<FolderIcon />}
    />
  </div>
);

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem>
  </div>
);
